/**
 * The landing's motion is CSS driven by classes; these helpers schedule the
 * class changes exactly as the approved page's script does. Browser only:
 * call them from effects.
 */

/** Steps as [ms, fn] pairs; returns a cancel that clears every pending step. */
export type Step = [number, () => void];

export function seq(steps: Step[]): () => void {
  const ids = steps.map(([t, fn]) => window.setTimeout(fn, t));
  return () => ids.forEach((id) => window.clearTimeout(id));
}

export function reducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/** Add and remove classes without React re-rendering: a static className plus these keeps both in step. */
export function toggleClass(el: Element | null, cls: string, on: boolean): void {
  el?.classList.toggle(cls, on);
}

/** Force a style flush so a transition-less reset takes before the next class lands. */
export function reflow(el: HTMLElement): void {
  void el.offsetWidth;
}
